import { render } from "./SitzungsantraegeModalEntscheiden.pug?vue&type=template&id=64f73060&lang=pug"
import script from "./SitzungsantraegeModalEntscheiden.js?vue&type=script&lang=js"
export * from "./SitzungsantraegeModalEntscheiden.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__